export enum LoginInputFlow {
  EMAIL = 'email',
  SSO = 'sso',
}
